import { FC } from "react";
import styles from "./Link.module.scss";
import { getChannelLink, openPlatformLink } from "../../../utils/platform-links";

interface IChannelLinkProps {
    caption: string;
}

export const ChannelLink: FC<IChannelLinkProps> = ({ caption }) => {
    const href = getChannelLink();
    return (
        <a
            className={styles.link}
            href={href || "#"}
            onClick={(e) => {
                if (!href) {
                    e.preventDefault();
                    return;
                }
                e.preventDefault();
                openPlatformLink(href);
            }}
        >
            { caption }
        </a>
    );
}